module.exports = __webpack_public_path__ + "static/media/fulllogo.4d84182a.png";